module.exports = __webpack_public_path__ + "static/media/the-pursuit-of-happyness.6b665a0b.webp";